import { Card, Divider, Grid, Stack, Typography } from '@mui/material';
import { VALIDATIONS_ASSETS, VALIDATIONS_COMPANIES } from '../../constants/paths';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Validations = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={6}>
        <Card
          sx={{ p: 3, cursor: 'pointer' }}
          onClick={() => {
            history.push({ pathname: VALIDATIONS_COMPANIES });
          }}>
          <Stack direction="column" alignItems="center" spacing={1}>
            <Typography variant="h6" color="text.primary">
              {t('validations.companies.title')}
            </Typography>
            <Divider />
            <Typography variant="body2">
              {t('validations.companies.description')}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item xs={6}>
        <Card
          sx={{ p: 3, cursor: 'pointer' }}
          onClick={() => {
            history.push({ pathname: VALIDATIONS_ASSETS });
          }}>
          <Stack direction="column" alignItems="center" spacing={1}>
            <Typography variant="h6" color="text.primary">
              {t('validations.assets.title')}
            </Typography>
            <Divider />
            <Typography variant="body2">
              {t('validations.assets.description')}
            </Typography>
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Validations;
